module.exports = __webpack_public_path__ + "img/saude.cbdbe963.svg";